import React from 'react';
import { RelatedIntent as UIRelatedIntent } from '@shopee/chatbot-ui';
import { ButtonAction, ButtonType, getButtonAction, getButtonType } from '@/utils/getButtonData';
import { TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/tracking/constants';
import { ChatbotUIBasicProps } from '@/types/common';
import { IntentSource, TRACKING_MSG_TYPE } from '@/utils/constants';
import RcmdUIOptimisationItem from './RcmdUIOptimisationItem';

export type RelatedIntentProps = {
  content: string;
  intents: {
    bot_id: number;
    intent_id: number;
    intent_name: string;
    is_ds_predicted?: boolean;
  }[];
  useUIOptimisationRecommender?: boolean;
} & ChatbotUIBasicProps;

const RelatedIntent: React.FC<RelatedIntentProps> = (props) => {
  const { customCallback = {}, useUIOptimisationRecommender } = props;
  const buttonGroup = {
    layout: 'vertical',
    buttons: props?.intents?.map((intent, index) => {
      const text = intent.intent_name;
      const trackingData = {
        bypassClickTracking: true,
        trackingname: TRACKING_TYPE.TASK_BOT_RCMD_HOT_QUESTION,
        trackingsection: TRACKING_SECTION[TRACKING_TYPE.TASK_BOT_RCMD_HOT_QUESTION],
        trackingtarget: TRACKING_TARGET[TRACKING_TYPE.TASK_BOT_RCMD_HOT_QUESTION],
        trackingdataBasic: {
          chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
          chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
          taskbot_id: props.taskbotInfo?.task_bot_id,
          taskflow_id: props.taskbotInfo?.flow_id,
          node_point_id: props.nodePointId,
          kb_bot_id: props.kbBotId,
          if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
          intent_id: intent.intent_id,
          question_content: intent.intent_name,
          location: index,
          button_type: ButtonAction.JumpIntent.toString(),
          button_id: intent.intent_id?.toString?.(),
          tf_node_id: props.tfNodeId,
          tf_case_id: props.tfCaseId,
          question_id: intent.intent_id,
          endnode_id: props?.taskbotInfo?.node_id,
          is_ds_predicted: intent?.is_ds_predicted,
        },
      };

      return {
        type: getButtonType(ButtonType.Link),
        text,
        action: {
          ...intent,
          func: getButtonAction(ButtonAction.JumpIntent),
          info: { ...props, trackingData },
          nextParams: {
            session_id: props.sessionId,
            intent_id: intent.intent_id,
            kb_bot_id: intent.bot_id,
            source: IntentSource.RelatedIntent, // 根据 be 需要修改 reply 1004 的 source
            is_category: false,
            thread_node_id: props.threadNodeId,
            thread_id: props.threadId,
            thread_id_v2: props.threadIdV2,
            round_id: props.roundId,
            is_bypass: false,
            dialogue_id: props.dialogueId,
          },
          customCallback,
        },
        trackingData,
        ...RcmdUIOptimisationItem(text, useUIOptimisationRecommender),
      };
    }),
  };

  return (
    <UIRelatedIntent
      className={useUIOptimisationRecommender ? 'rcmd-ui-optimisation-container' : ''}
      content={props.content}
      buttonGroup={buttonGroup as any}
    />
  );
};

export default RelatedIntent;
